<app-btn-nueva-persona  *appRole="['Personas.Crear']" ></app-btn-nueva-persona>
<br />

<app-listado-personas  *appRole="['Personas.Listado']" ></app-listado-personas>
